/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'whatwg-fetch';
import { BrowserRouter, Route, MemoryRouter } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Provider } from 'react-redux';
import { QueryParamProvider } from 'use-query-params';

import ScrollToTop from 'components/ScrollToTop';
import ErrorBoundary from 'components/ErrorBoundary';
import SplashPage from 'components/SplashPage/SplashPage';

import initializeSentry from 'monitoring/initializeSentry';
import ThemeProvider from 'themes/ThemeProvider';
import extractSsoParams from 'utils/extractSsoParams';
import { thunks } from 'store/toolkit';
import { FocusAnchorProvider } from 'utils/FocusRefContext';

import { isEmbedded } from 'utils/utils';

import store from './store/store';
import applyGoogleTranslateFix from './googleTranslateFix';

const App =
  process.env.REACT_APP_STANDALONE_CHAT === 'true'
    ? React.lazy(() => import('./chat/StandaloneChatApp'))
    : React.lazy(() => import('./App'));

applyGoogleTranslateFix();

const updatedUrl = extractSsoParams(window.location.href);
window.history.replaceState(null, null, updatedUrl);

initializeSentry();

store.dispatch(
  thunks.config.initialize({ integrationToken: localStorage.getItem('integrationToken') })
);

const Router = isEmbedded() ? MemoryRouter : BrowserRouter;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <ThemeProvider>
      <Router initialEntries={isEmbedded() ? [window.location] : undefined}>
        <QueryParamProvider ReactRouterRoute={Route}>
          <ErrorBoundary>
            <LastLocationProvider>
              <FocusAnchorProvider>
                <ScrollToTop>
                  <SplashPage>
                    <React.Suspense fallback={null}>
                      {/** Fallback is null because SplashPage uses Redux state to hide children until App has mounted */}
                      <App />
                    </React.Suspense>
                  </SplashPage>
                </ScrollToTop>
              </FocusAnchorProvider>
            </LastLocationProvider>
          </ErrorBoundary>
        </QueryParamProvider>
      </Router>
    </ThemeProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
